export default "__VITE_ASSET__a785a089__"